<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="card">
      <template v-if="hasPayPassword">
        <div class="c_p_j">{{ $t('setting.old_pwd') }}</div>
        <van-field v-model="old_password" :placeholder="$t('setting.old_pwd_tip')" type="password" />
      </template>
      <div class="c_p_j">{{ $t('setting.new_pwd') }}</div>
      <van-field v-model="o_new_password" :placeholder="$t('setting.new_pwd_tip')" type="password"/>
      <div class="c_p_j">{{ $t('setting.new_pwd1') }}</div>
      <van-field v-model="t_new_password" :placeholder="$t('setting.new_again_tip')" type="password"/>
    </div>
    <div class="sub-btn" @click="save()">
      {{ $t('q59') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password: "",
      t_new_password: "",
      old_password: "",
      userInfo: {},
    };
  },
  computed: {
    hasPayPassword() {
      return !!(this.userInfo && this.userInfo.paypassword);
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    save() {
      if (!this.o_new_password) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (!this.t_new_password) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.hasPayPassword && !this.old_password) {
        this.$toast.fail(this.$t("setting.prefect"));
        return false;
      }
      if (this.o_new_password !== this.t_new_password) {
        this.$toast(this.$t("setting.pwd_error"));
        return false;
      }
      const data = {
        paypassword: this.o_new_password,
        paypassword2: this.o_new_password,
      };
      if (this.hasPayPassword) {
        data.old_password = this.old_password;
      }
      this.$http({
        method: "post",
        data,
        url: "user_set_paypw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          setTimeout(() => {
            this.$router.back();
          }, 500);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang='less' scoped>
.sub-page{
  min-height: 100vh;
  background: #000000;
  padding-bottom: 40px;
}
.card{
  background: #141414;
  border-radius: 16px;
  margin: 24px;
  overflow: hidden;
  /deep/ .van-cell{
    padding: 24px 28px;
    font-size: 28px;
  }
}
.sub-btn{
  background: #c9a84c;
  margin: 40px 24px 0;
  border-radius: 44px;
  color: #000;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  padding: 24px 0;
}
.c_p_j{
  padding: 26px 28px 0;
  color: #c9a84c;
  font-size: 26px;
}
</style>
